import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardActions,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Typography,
} from "@mui/material";
import { PeopleAltRounded } from "@mui/icons-material";
import { ErrorContext } from "../../components/GympinPagesProvider";
import { corporate_getCorporateGroups } from "../../network/api/corporate.api";
import { SetRppPersonnel } from "../../helper/pocket";
import _UserTableRow from "./partials/_UserTableRow";
import _UserListFilters from "./partials/_UserListFilters";

export const _UserList = ({
    personnel,
    corporate,
    sortBy,
    setSortBy,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    selectedGroup,
    setSelectedGroup,
    setSearchText,
}) => {
    const error = useContext(ErrorContext);
    const [groups, setGroups] = useState(null);

    useEffect(() => {
        getGroups();
    }, []);

    function getGroups() {
        if (!corporate?.Id) return;
        corporate_getCorporateGroups({ Id: corporate.Id }).then(result => {
            setGroups(result.data.Data || []);
        }).catch(e => {
            try {
                error.showError({ message: e.response?.data?.Message || "خطا در دریافت لیست گروه‌ها" });
            } catch (f) {
                error.showError({ message: "خطای نامشخص" });
            }
        });
    }

    const isLoading = !personnel;
    const personnelList = personnel?.content || [];
    const totalCount = personnel?.totalElements || 0;

    return (
        <Card
            elevation={0}
            sx={{
                mt: 3,
                mb: 8,
                width: '100%',
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                overflow: 'hidden'
            }}
        >
            {/* Toolbar Filter & Search */}
            <_UserListFilters
                selectedGroup={selectedGroup}
                setSelectedGroup={setSelectedGroup}
                groups={groups}
                setSearchText={setSearchText}
                totalCount={totalCount}
            />

            {/* Table Container */}
            <TableContainer>
                <Table aria-label="لیست کارمندان" sx={{ minWidth: 750 }}>
                    <TableHead>
                        <TableRow
                            sx={{
                                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'
                            }}
                        >
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem', width: 60 }}>
                                تصویر
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                <TableSortLabel
                                    active={sortBy.Name === "User.FullName"}
                                    direction={sortBy.Desc ? "desc" : "asc"}
                                    onClick={() => setSortBy({ Name: "User.FullName", Desc: !sortBy.Desc })}
                                >
                                    نام و نام خانوادگی
                                </TableSortLabel>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                گروه
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                مجموع اعتبار
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                تعداد اعتبار
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                نزدیک‌ترین انقضا
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem' }}>
                                <TableSortLabel
                                    active={sortBy.Name === "User.Birthday"}
                                    direction={sortBy.Desc ? "desc" : "asc"}
                                    onClick={() => setSortBy({ Name: "User.Birthday", Desc: !sortBy.Desc })}
                                >
                                    تاریخ تولد
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" sx={{ fontWeight: 800, color: 'text.secondary', fontSize: '0.82rem', width: 70 }}>
                                عملیات
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                                    <CircularProgress size={36} thickness={4} sx={{ color: 'primary.main', mb: 1.5 }} />
                                    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                        در حال بارگذاری اطلاعات پرسنل...
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : personnelList.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                                    <Box
                                        sx={{
                                            width: 64,
                                            height: 64,
                                            borderRadius: '50%',
                                            bgcolor: 'rgba(28, 139, 156, 0.08)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mx: 'auto',
                                            mb: 2,
                                            color: 'primary.main'
                                        }}
                                    >
                                        <PeopleAltRounded sx={{ fontSize: 32 }} />
                                    </Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'text.primary', mb: 0.5 }}>
                                        کارمندی یافت نشد
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 360, mx: 'auto' }}>
                                        موردی با فیلترها و مشخصات وارد شده پیدا نشد. می‌توانید فیلترها را تغییر داده یا کارمند جدید اضافه کنید.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            personnelList.map((row) => (
                                <_UserTableRow key={row.Id || row.name} row={row} />
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination Footer */}
            {personnel && (
                <CardActions
                    sx={{
                        p: 1.5,
                        px: 2.5,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        justifyContent: "flex-end",
                        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)'
                    }}
                >
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        count={totalCount}
                        labelRowsPerPage="تعداد در هر صفحه:"
                        labelDisplayedRows={({ from, to, count }) => `نمایش ${from} تا ${to} از مجموع ${count} کارمند`}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        onRowsPerPageChange={(event) => {
                            const newRpp = parseInt(event.target.value, 10);
                            SetRppPersonnel(newRpp);
                            setRowsPerPage(newRpp);
                            setPage(0);
                        }}
                    />
                </CardActions>
            )}
        </Card>
    );
};

export default _UserList;
